import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCirclereact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 7.25,
		stroke: "#24C17F",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 8L7.13333 10L11.4 6",
		stroke: "#24C17F",
		strokeWidth: 1.5
	})]
});
export default SvgCheckCirclereact;
